import { render, staticRenderFns } from "./Kanonismoi.vue?vue&type=template&id=612ac3a6"
import script from "./Kanonismoi.vue?vue&type=script&lang=js"
export * from "./Kanonismoi.vue?vue&type=script&lang=js"
import style0 from "./Kanonismoi.vue?vue&type=style&index=0&id=612ac3a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports